var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-id-auth"},[_c('div',{staticClass:"page-body"},[(_vm.step === 0)?_c('info',{attrs:{"user-info":_vm.userInfo,"id-types":_vm.idTypes},on:{"next":_vm.onNext}}):_c('apply',{attrs:{"user-info":_vm.userInfo,"id-types":_vm.idTypes},on:{"prev":_vm.onPrev}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }